import { t } from 'app/core/i18n/i18n';

export const UNASSIGNED_PARTNERS_EXPORT_ID = 'unassigned-partners-list';

/**
 * The sheet/report title. This is a FUNCTION, not a constant: a module-level `const TITLE =
 * t('...')` is evaluated at IMPORT time — before the app has resolved a language — so it would
 * freeze the raw key into the export forever. Called at export time, it resolves to whatever
 * language the user is actually in.
 */
export const unassignedPartnersExportTitle = (): string => t('routing.SUB_ROUTE_PARTNERS.UNASSIGNED_EXPORT.TITLE');

// Values are translation keys; the export processor resolves them to the user's language when the
// sheet is built (see ExportTaskProcessor.localizeItemProperties).
export const UNASSIGNED_PARTNERS_LOCALIZED_PROPERTIES: Record<string, string> = {
  name: 'EXPORT_COLUMNS.NAME',
  externalCode: 'EXPORT_COLUMNS.CODE',
  address: 'EXPORT_COLUMNS.ADDRESS',
  contact: 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_EXPORT.COLUMNS.CONTACT',
  phone: 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_EXPORT.COLUMNS.PHONE',
  email: 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_EXPORT.COLUMNS.EMAIL',
  assignedRoutes: 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_EXPORT.COLUMNS.ASSIGNED_ROUTES',
};
